var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['permits-item', {'permits-item--has-action': _vm.hasAction}],style:(_vm.style),on:{"click":_vm.onAction_ClickHandler}},[_c('div',{staticClass:"permits-item__content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"permits-item__footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d93898a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/permits/PermitsItem.vue
// module id = null
// module chunks = 